import { HttpService } from '@/utils/http/index'

const $http = new HttpService()

/**
 * 获取运费审核列表
 * @param params
 */
export const getDeliveryListApi = (params: {}) => $http.get('/distribution/rules_list', params)

/**
 * 驳回运费审核
 * @param params
 */
export const rejectDeliveryApi = (data:object) => $http.get('/distribution/rules_reject', data)

/**
 * 通过运费审核
 * @param params
 */
export const passDeliveryApi = (data:object) => $http.get('/distribution/rules_check', data)
